export const INDIVIDUALS = 'individuals';
export const GROUP = 'group';
